import { isModeratorOrHigher } from '@/utilities';

export default function ({ redirect, store }) {
  if (store.state.token && isModeratorOrHigher(store.state.role)) {
    return redirect('/admin/submissions');
  } else {
    return redirect('/log-in');
  }
}
